import React, { createContext, useContext, useState } from "react";

export interface IFormQuestion extends Document {
	customer: string;
	type: FormQuestionModuleType;
	question: FormQuestionType;
}

export enum FormQuestionModuleType {
	candidate = 1,
}

export enum FormQuestionType {
	studentLoan = 1,
	healthDeclaration = 2,
	safeQuardingQuestionaire = 3,
	nonUk = 4,
	socialMediaChecks = 5,
	noReferenceConsent = 6,
	referenceInternalApproval = 7,
	healthAndDisability = 8,
	candidateBorough = 9,
	healthDeclarationSignature = 10,
	referenceImmediateConsent = 11,
	bookingConfirmationNationalInsurance = 12,
	dbsBarredCheckUds = 13,
	educationalDisciplinaryProceedings = 14,
	keepingChildrenSafeExtendedCaution = 15,
	clientSpecialism = 16,
	referenceNote = 17,
	clientInternalIdSearch = 18,
	recordBoxNotes = 19,
	bookingConfirmationReferenceReceived = 20,
	healthDeclarationConcise = 21,
	keepingChildrenSafeKCSIE = 22,
	KeepingChildrenSafeProhibited = 23,
	candidateInterviewQuestions = 24,
	employmentHistoryExtended = 25,
	homeOfficeShareCode = 26,
	bookingConfirmationEwcConfirmation = 27,
	onboardingBankRequired = 28,
	onboardingDocumentsRequired = 29,
	referencePreventGenericEmail = 30,
	onboardingEmploymentHistoryRequired = 31,
	setDefaultPayRateToWeekly = 32,
	candidateSasOptIn = 33,
	overseasDeclarationExtended = 34,
	educationReferenceExtended = 35,
	invoiceTrackingCategories = 36,
	dunbarOnboardingRequirements = 37,
	reference24months = 38,
	onlineCheckConsent = 39,
	candidateTitle = 40,
	candidatePronoun = 41,
	candidateUmbrellaPaye = 42,
	holdenReferenceCustomMessage = 43,
	onboardingDocumentsNoCvRequired = 44,
	longtermTeacherHealthDeclaration = 45,
	employmentHistoryFull = 46,
	candidateExportFirstBooking = 47,
	onboardingTeacherPayScaleInput = 48,
	candidateP45 = 49,
	showOnlyHourlyRate = 50,
	additionalDbsComments = 51,
	defaultSendBookingConfirmationToYes = 52,
	moveCandidateSourceToTop = 53,
	candidateAssigneeFirst = 54,
	onboardingDocumentsPassportOnly = 55,
	healthSafetyCheckBooking = 56,
	poNumberBooking = 57,
	onboardingMedicalIntro = 58,
	medicalHealthDeclaration = 59,
	extendedOnboardingAbroadCheck = 60,
	hideSpecificDocumentsOnboarding = 61,
	candidateContractRoleType = 62,
	candidateRTWVerification = 63,
	onboardingCandidateInterview = 68,
	onboardingOverseas = 69,
	onboardingNumberRequired = 70,
	onboardingMedicalRequirements = 71,
	onboardingAlternativeReferenceDisclaimer = 72,
	onboardingVidaDeclaration = 73,
	onboardingTeacherOccupations = 74,
	onboardingHideProbation = 75,
	bookingConfirmationSafeguarding = 76,
	onboardingReferenceEqualOppotunities = 77,
	onboardingOverseasOffence = 78,
	overseasDeclarationExtendedReason = 79,
	bookingSplitDaysOut = 80,
	rightToWorkSubDocumentItems = 81,
	bookingSplitDaysOutKeepProfit = 82,
	bookingSplitDaysOutKeepProfitKeepMargin = 83,
	bookingPreventExcludeFromProfit = 84,
	bookingShowDayLength = 85,
	splitBookingDays = 86,
	showMedicalReferenceQuestions = 90,
	showAckButton = 100,
	showDocumentApproval = 110,
	candidateSourceRequired = 120,
	candidateEmploymentStartDate = 121,
	bookingTypeStandardOptionsOnly = 130,
	complianceTrn = 140,
	complianceSafeguarding = 141,
	compliancePreventTraining = 142,
	complianceBirthCertificate = 143,
	complianceNameChange = 144,
	complianceCyberSecurity = 145,
	complianceDbsDocsOnly = 146,
	complianceDbsUseUpdateService = 147,
	complianceBarredCheckDate = 148,
	additionalInterviewQuestions = 150,
	additionalSafeguardingInterviewQuestions = 151,
	hideInterviewQuestion = 152,
	interviewVideo = 153,
	hideInterivewPersonal = 154,
	hideInterviewSubjects = 155,
	hideInterviewQuestionsHolden = 156,
	showInterviewQuestionsHolden = 157,
	showStudentNameColumn = 160,
	showTrnNumberNotes = 161,
	showTrnNumberField = 162,
	bookingTutorVisibility = 200,
	candidateDefaultFuture = 210,
	candidateDefaultHold = 211,
	dbsDeclarationRead = 220,
	tutitionHoursTaught = 230,
	tuitionNoHoursRemaining = 231,
	alternativeCharacterReferenceProForma = 240,
	vidaReferenceQuestions = 250,
	referenceTypeNoEducation = 251,
	referenceSubstantiatedSafeguardingAllegations = 252,
	referenceAttendanceAsReliability = 253,
	bookingTableAsc = 300,
	onboardingReferenceAllWorkHistory = 310,
	bookingConfirmationReferenceReceivedTotal = 320,
	bookingConfirmationHolidayPercentage = 321,
	vidaReferenceCustomMessage = 322,
	interviewTypesBasic = 323,
	simpleClientBookingConfirmation = 324,
	referenceDatesAsDates = 325,
	showDaytoDayBooking = 326,
	candidatesBookedTab = 330,
	clientArea = 340,
	lockKCSIE = 350,
	onboardingProfilePhotoRequired = 360,
	ComplianceUser = 370,
	AvailabilityLastChecked = 371,
	SubsidiarySubject = 372,
	SubjectToNotice = 373,
	EmploymentPreference = 374,
	Governance = 375,
	MATHQ = 376,
	OfstedRating = 377,
	DateOfstedReportChecked = 378,
	Boarding = 379,
	LicenceToIssueSponsorship = 380,
	SchoolMATInformation = 381,
	AgencySpendTotal = 382,
	DesiredLocationMultiple = 383,
	CCSClient = 384,
	identityGroup1Rename = 390,
	showCVCompliance = 391,
	showHomeOfficeShareCompliance = 392,
	bookingConfirmationChildcareDisqualification = 400,
	bookingConfirmationHealthDeclaration = 401,
	bookingConfirmationSocialMedia = 402,
	bookingConfirmationHideQualificationDates = 403,
	bookingConfirmationCandidateOccupation = 404,
	compliance2Pof = 410,
	bookingExportCreatedBy = 420,
	bookingExportCandidateAssignee = 421,
	candidateCVExportMinimal = 422,
	customClientRemarkTags = 430,
	customCandidateRemarkTags = 431,
	customClientRemarkTagsExtended = 432,
	customCandidateRemarkTagsExtended = 433,
	candidateRTWAlertsVerification = 440,
	candidateDBSVerification = 441,
	candidateDBSCheckVerification = 442,
	candidateDBSUpdateServiceVerification = 443,
	candidateTRNVerification = 444,
	candidateHealthSafetyVerification = 445,
	candidateVettingHideDeclarations = 446,
	clientTrustRename = 450,
	complianceDbsUpdateService1Month = 460,
	// dataProviderSync = 470, deprecated
	OnlineSearch = 480,
	timesheetAdditionalDiscliamer = 490,
	timesheetShowChargeRate = 491,
	timesheetShowChargeRateTotal = 492,
	timesheetShowUnits = 493,
	timesheetShowUnitBreakdown = 494,
	timesheetLockViaPaymentRun = 495,
	removeEmailReferencePdf = 510,
	onboardingSingleReference = 600,
	onboardingDob18 = 601,
	OtherNames = 610,
	StandardBookingConfirmationEmail = 630,
	onboardingWelshRequirements = 640,
	invoiceDescriptionSimplified = 650,
	invoiceDefaultTextBookingOnCosts = 651,
	invoiceContactOnBookings = 652,
	alternateCandidateSourceItems = 660,
	automations = 700,
	canRunAutomationsImmediately = 701,
	onboardingReferenceOptionalTelephone = 800,
	healthDeclarationFitToWorkOverride = 801,
	bookingConfirmationBookedBy = 802,
	healthDeclarationHideExpectantMother = 803,
	invoiceDescriptionTimesheetApproval = 810,
	threeMonthOnboardingAbroadCheck = 811,
	additionalSendInterviewQuestions = 812,
	currentCriminalOffence = 813,
	healthSafetyBookingRequired = 814,
	healthSafetyBookingDefaultTrue = 815,
	candidateExportEmail = 820,
	newFormationReferenceCustomMessage = 821,
	referenceReminder2Days = 823,
	simplifiedBankDetails = 830,
	requireCandidatePayTypeSelection = 831,
	candidateExportAssigneeTeams = 840,
	trackCandidateSectionCompleteStatus = 900,
	safeInEducationCheckConsentDate = 901,
	csvExportDefault = 1010,
	edunId = 1030,
	threeMonthsUpdateServiceExpiring = 1040,
	sixMonthsUpdateServiceExpiring = 1041,
	threeMonthsTRNExpiring = 1042,
	sixMonthsTRNExpiring = 1043,
	timesheetNumberPrependS = 1051,
	timesheetNumberExport = 1052,
	overseasCheckReporting = 1060,
	prohibitionCheckReporting = 1061,
	customJobTypes = 1070,
	showMatrixDbsApplication = 1080,
	bookingEnableLockedDays = 1090,
	pabExport = 1100,
	incrementalPlacementId = 1101,
	newStarterCandidateStatus = 1102,
	referenceSubmissionShowCandidateSignature = 1103,
	bookingCsvExports = 1104,
	showPayeTypeBookingConfirmation = 1105,
	timesheetESignature = 1106,
	allowPartialTuitionReports = 1107,
	voipIntegration = 1108,
	bankDetailsValidate = 3000,
	includeClientDetails = 4001,
	googleCheckDate = 4004,
	//Mobile app
	mobileAppLinking = 2000,
	QPSPayroll = 4003,
	//rec Audit Consent
	RECOnboarding = 5000,
}

export interface GlobalFormQuestionsState {
	formQuestions: IFormQuestion[];
	setFormQuestions: (formQuestions: IFormQuestion[]) => void;
}

export const initialFormQuestionsState: GlobalFormQuestionsState = {
	formQuestions: null,
	setFormQuestions: () => {},
};

const FormQuestionsStoreContext = createContext<GlobalFormQuestionsState>(initialFormQuestionsState);

type Props = {
	children: React.ReactChild;
};

export const FormQuestionsStoreProvider = ({ children }: Props) => {
	const [formQuestions, setFormQuestions] = useState<IFormQuestion[]>(null);

	return (
		<FormQuestionsStoreContext.Provider
			value={{
				formQuestions,
				setFormQuestions,
			}}>
			{children}
		</FormQuestionsStoreContext.Provider>
	);
};

export const useFormQuestions = () => useContext(FormQuestionsStoreContext);
